import Tone from 'tone';

import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {getImaginaryReal, getImaginaryRealSync} from 'constants/waveforms.js';
import PolyParameter from 'parameters/PolyParameter.js';

import {bulkUpdate} from 'utils/bulkUpdate.js';
import {AUDIO_FX} from 'constants/effect-types.js';
import {setEffectParameterValues} from 'actions/index.js';
import {AbstractParameter, IntegerParameter} from 'parameters/AbstractParameter.js';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import {uuid} from 'uuidv4';
import {isNumber} from 'utils/IsNumber.js';


const DEFAULT_NOTE = new Tone.Frequency('C3');
const PORTAMENTO_FACTOR = 20.0;
const DEFAULT_POLYPHONY = 6;
const RAMP_TIME = 0.1;
var id = 0;

class AbstractOscillator {
    constructor(sequencerEngine, mixSession, context, synthFactory, pitchEnvelope, create=true, track) {
        this.bulk = {};
        this.sequencerEngine = sequencerEngine;
        this.id = uuid();
        this.track = track;
        this.name = 'Osc ' + this.id;
        this.store = sequencerEngine.store;
        this.mixSession = mixSession;
        this.context = context.getCopy().forSubDevice(this).forOscillator(this);
        this.pitchEnvelope = pitchEnvelope;

        this.synthFactory = synthFactory;
        // keeps track whether we've set the polyphony parameter
        this.polyphonySet = false;
        this.volume = new Tone.Gain(0.4);
    }

    dispose() {
        if (this.synth) {
           // this.synth.dispose();
            this.disposeSynth();
        }

        this.getParameters().forEach(s => s.dispose());
        this.parameters = undefined;
        
    }

    create() {
        this.initVoices();
        this.setupParameters();
        this.setupWaveformParameters();
    }

    isInitialized(){
        return this.synth !== undefined;
    }

    getEffectType() {
        return AUDIO_FX;
    }

    getCopy(context, pitchEnvelope, synth) {
        synth.oscillatorFrequency = this.oscillatorFrequency;
        synth.oscillatorLevel = this.oscillatorLevel;
        synth.detune = this.detune;
        synth.polyphony = this.polyphony;
        synth.portamento = this.portamento;
        synth.oscillatorType = this.oscillatorType;
        synth.pulseWidth = this.pulseWidth;
        
        return synth;
    }

}

export default AbstractOscillator;
